import axios from 'axios';

function fail(err, fallback) {
  const msg = err?.response?.data?.msg
    || err?.response?.data?.message
    || err?.message
    || fallback;
  return { success: false, message: msg };
}

/**
 * Motor private paybill — quotations-api validates GIS payment and enqueues SQS (same as STK).
 */
const motorPaybillApi = {
  async confirmMotorPaybillPayment({ quoteId, accountNumber }) {
    try {
      const res = await axios.post(
        '/customer/quotation/payment/paybill-confirm',
        {
          quoteId: Number(quoteId),
          accountNumber: String(accountNumber || '').trim(),
        },
        { _skipErrorRedirect: true },
      );
      const body = res?.data;
      if (body?.success) {
        return {
          success: true,
          message: body.msg || 'Payment confirmed. Your cover is being issued.',
        };
      }
      return {
        success: false,
        message: body?.msg || body?.message || 'Payment not yet received. Complete Paybill payment and try again.',
      };
    } catch (e) {
      return fail(e, 'Payment confirmation failed');
    }
  },
};

export default motorPaybillApi;
